(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CareCoordination', CareCoordination);

    CareCoordination.$inject = ['$resource'];

    function CareCoordination ($resource) {
        var resourceUrl =  'api/care-coordinations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllWithEagerRelationshipsByChart': {url: 'api/care-coordinations/by-chart/:chartId', method: 'GET', isArray: true}
        });
    }
})();
